import { IMyDealsState } from '../../types/myDeals';

const defaultState: IMyDealsState = {
  isAvailable: false,
};

export function myDealsReducer(state: IMyDealsState = defaultState): IMyDealsState {
  return state;
}
